import { useMemo } from 'react';
import { AxiosError } from 'axios-cad-nx';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { errorOccurredWhile } from '../helpers/error-occurred-while';

export function useSaveMutationErrorMessage(serverErrorOccurredWhile: string) {
    const { mutation } = useIntegratedForm();

    return useMemo(() => {
        if (!(mutation?.error instanceof AxiosError) || !mutation?.error?.response?.data?.error) {
            return;
        }

        if (mutation?.error?.response?.status === 500) {
            return errorOccurredWhile(serverErrorOccurredWhile);
        }

        return mutation.error.response.data.error;
    }, [mutation, serverErrorOccurredWhile]);
}
